"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 表格配置
 * paramname 排序必须字段
 *
 */
var utils_1 = __importDefault(require("../commonutil/utils"));
var fieldtools_1 = __importDefault(require("../commonutil/fieldtools"));
//评级变动配置
function getRatingChangeStr(ratingChange) {
    var ratingChangeName = "";
    switch (ratingChange + '') {
        case '0':
            ratingChangeName = '调高';
            break;
        case '1':
            ratingChangeName = '调低';
            break;
        case '2':
            ratingChangeName = '首次';
            break;
        case '3':
            ratingChangeName = '维持';
            break;
        case '4':
            ratingChangeName = '无';
            break;
        default:
            ratingChangeName = '-';
            break;
    }
    return ratingChangeName;
}
;
//作者名字处理:len需要截取的字符串长度2个单位等于一个汉字
function authorFormat(v, len) {
    var authorInfo = v.author ? v.author : '';
    var anthorStr = '';
    if (authorInfo != '' && authorInfo.length > 0) {
        for (var i = 0; i < authorInfo.length; i++) {
            var info = authorInfo[i] || [];
            // let name = authorInfo[i] ? authorInfo[i].split('.')[1] : '';
            var name_1 = (info === null || info === void 0 ? void 0 : info.replace(/^\d+./, '')) || "";
            if (len) {
                name_1 = utils_1["default"].txtLeft(name_1, len, true);
            }
            var id = info ? info.split('.')[0] : '';
            anthorStr += "<a class=\"tt-wrap\" href=\"personalpublish.jshtml?authorid=" + id + "&orgcode=" + v.orgCode + ("\">" + name_1 + "</a>&nbsp;");
        }
    }
    return anthorStr;
}
;
//单个机构和单个作者正文跳转地址
function getZWUrl(v) {
    if (v.columnType == '个股研报') {
        var date = ((v.publishDate).split(' ')[0]).replace(/-/g, '');
        return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
    }
    ;
    if (v.columnType == '行业研报') {
        return "<a href=\"/report/zw_industry.jshtml?infocode=" + v.infoCode + ("\">" + v.title + "</a>");
    }
    ;
    if (v.columnType == '券商晨会') {
        return "<a href=\"/report/zw_brokerreport.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
    }
    ;
    if (v.columnType == '宏观研究' || v.columnType == '宏观策略') {
        return "<a href=\"/report/zw_macresearch.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
    }
    ;
    if (v.columnType == '策略报告') {
        return "<a href=\"/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
    }
}
;
//单个机构和单个作者类型跳转地址
function geTypeUrl(v) {
    if (v.columnType == '个股研报') {
        return "<a href=\"/report/stock.jshtml\">" + v.columnType + "</a>";
    }
    ;
    if (v.columnType == '行业研报') {
        return "<a href=\"/report/industry.jshtml\">" + v.columnType + "</a>";
    }
    ;
    if (v.columnType == '券商晨会') {
        return "<a href=\"/report/brokerreport.jshtml\">" + v.columnType + "</a>";
    }
    ;
    if (v.columnType == '宏观研究' || v.columnType == '宏观策略') {
        return "<a href=\"/report/macresearch.jshtml\">" + v.columnType + "</a>";
    }
    ;
    if (v.columnType == '策略报告') {
        return "<a href=\"/report/strategyreport.jshtml\">" + v.columnType + "</a>";
    }
}
;
//单个机构和单个作者研究对象取值和跳转地址
function getYJDXUrl(v) {
    if (v.columnType == '个股研报') {
        if (v.stockCode != '' && v.stockName != '') {
            return "<a href=\"/report/" + v.stockCode + ".html\">" + v.stockName + "(" + v.stockCode + ")</a>";
        }
    }
    else if (v.columnType == '行业研报') { //产品确认：跳转只带行业代码即可，不带机构
        if (v.industryName != '' && v.industryCode != '') {
            return "<a href=\"/report/industry.jshtml?hyid=" + v.industryCode + ("\">" + v.industryName + "</a>");
        }
    }
    else {
        return '';
    }
}
;
var config = {
    //首页行业研究
    "industryresearch": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                th: function name(v) {
                    return '行业名称';
                },
                td: function (v) {
                    var bkcode = v.industryCode ? v.industryCode > 999 ? 'bk' + v.industryCode : 'bk0' + v.industryCode : '';
                    return "<a href=\"//quote.eastmoney.com/center/boardlist.html#boards-" + bkcode + ("\">" + v.industryName + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    return '<span class="hqspan" data-hqtype="zdf" data-code="' + v.industryCode + '"></span>';
                }
            },
            {
                width: 130,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    var bkcode = v.industryCode ? v.industryCode > 999 ? 'bk' + v.industryCode : 'bk0' + v.industryCode : '';
                    return "<a href=\"/report/industry.jshtml?hyid=" + v.industryCode + "\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"/bkzj/" + v.industryCode + ".html\">\u8D44\u91D1\u6D41</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + bkcode + ".html\">\u80A1\u5427</a>&nbsp;\n                  <a href=\"//stock.eastmoney.com/hangye/hy" + v.industryCode + ".html\">\u4E13\u533A</a>";
                }
            },
            {
                width: 220,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_industry.jshtml?infocode=" + v.infoCode + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财<br>评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '-';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级<br>变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月行<br>业研报数';
                },
                td: function (v) {
                    return "" + v.count;
                }
            },
            {
                th: function name(v) {
                    return '日期';
                },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return date;
                }
            }
        ]
    },
    "indexnewreport": {
        theadfix: {
            thisyear_ylyc: function (v) {
                var currentYear = v.currentYear ? v.currentYear : '';
                return currentYear + '盈利预测';
            },
            nextyear_ylyc: function (v) {
                var nextyear = v.currentYear ? v.currentYear + 1 : '';
                return nextyear + '盈利预测';
            }
        },
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 60,
                paramname: 'stockCode',
                th: function name(v) {
                    return "\u80A1\u7968\u4EE3\u7801";
                },
                defaultsortType: '',
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.stockCode) + "\">" + v.stockCode + "</a>";
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '股票简称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.stockCode + (".html\">" + fieldtools_1["default"].fmtsname(v.stockName) + "</a>");
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"" + v.stockCode + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.stockCode + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                width: 130,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    var date = ((v.publishDate).split(' ')[0]).replace(/-/g, '');
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财<br>评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '-';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级<br>变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月<br>个股研<br>报数';
                },
                td: function (v) {
                    return "" + v.count;
                }
            },
            {
                th: function name(v) {
                    return '收益';
                },
                theadfix: 'thisyear_ylyc',
                td: function (v) {
                    var predictThisYearEps = "";
                    if (v.predictThisYearEps != undefined) {
                        predictThisYearEps = v.predictThisYearEps == '' ? '' : Number(v.predictThisYearEps).toFixed(3);
                    }
                    return predictThisYearEps;
                }
            },
            {
                th: function name(v) {
                    return '市盈率';
                },
                theadfix: 'thisyear_ylyc',
                td: function (v) {
                    var predictThisYearPe = "";
                    if (v.predictThisYearPe != undefined) {
                        predictThisYearPe = v.predictThisYearPe == '' ? '' : Number(v.predictThisYearPe).toFixed(2);
                    }
                    return predictThisYearPe;
                }
            },
            {
                th: function name(v) {
                    return '收益';
                },
                theadfix: 'nextyear_ylyc',
                td: function (v) {
                    var predictNextYearEps = "";
                    if (v.predictNextYearEps != undefined) {
                        predictNextYearEps = v.predictNextYearEps == '' ? '' : Number(v.predictNextYearEps).toFixed(3);
                    }
                    return predictNextYearEps;
                }
            },
            {
                th: function name(v) {
                    return '市盈率';
                },
                theadfix: 'nextyear_ylyc',
                td: function (v) {
                    var predictNextYearPe = "";
                    if (v.predictNextYearPe != undefined) {
                        predictNextYearPe = v.predictNextYearPe == '' ? '' : Number(v.predictNextYearPe).toFixed(2);
                    }
                    return predictNextYearPe;
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '行业';
                },
                td: function (v) {
                    var indvInduName = v.indvInduName ? v.indvInduName : '';
                    return "<a href=\"/report/industry.jshtml?hyid=" + v.indvInduCode + ("\">" + indvInduName + "</a>");
                }
            },
            {
                width: 65,
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return date;
                }
            }
        ]
    },
    "indexylyc": {
        theadfix: {
            jgtzpj: function (v) {
                return '机构投资评级(近六个月)';
            }
        },
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                paramname: 'stockCode',
                th: function name(v) {
                    return '代码';
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v) + "\">" + v.SECURITY_CODE + "</a>";
                }
            },
            {
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.SECURITY_CODE + (".html\">" + fieldtools_1["default"].fmtsname(v.SECURITY_NAME_ABBR) + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                paramname: 'total',
                th: function name(v) {
                    return '研报数';
                },
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_ORG_NUM) ? 0 : v.RATING_ORG_NUM;
                }
            },
            {
                th: function name(v) {
                    return '买入';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_BUY_NUM) ? 0 : v.RATING_BUY_NUM;
                }
            },
            {
                th: function name(v) {
                    return '增持';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_ADD_NUM) ? 0 : v.RATING_ADD_NUM;
                }
            },
            {
                th: function name(v) {
                    return '中性';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_NEUTRAL_NUM) ? 0 : v.RATING_NEUTRAL_NUM;
                }
            },
            {
                th: function name(v) {
                    return '减持';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_REDUCE_NUM) ? 0 : v.RATING_REDUCE_NUM;
                }
            },
            {
                th: function name(v) {
                    return '卖出';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_SALE_NUM) ? 0 : v.RATING_SALE_NUM;
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR1;
                    return (year || '') + '每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS1, { num: 3 });
                },
                icons: {
                    name: 'faq',
                    title: "\u9884\u6D4B\u6570\u636E\u6839\u636E\u5404\u673A\u6784\u53D1\u5E03\u7684\u7814\u62A5\u62A5\u544A\u6458\u5F55\u6240\u5F97\uFF0C\u4E0E\u672C\u7F51\u7AD9\u7ACB\u573A\u65E0\u5173\uFF1B\u5B9E\u9645\u6BCF\u80A1\u6536\u76CA\u4E3A\u7ECF\u6700\u65B0\u603B\u80A1\u672C\u8BA1\u7B97\u6240\u5F97"
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR2;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS2, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR3;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS3, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR4;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS4, { num: 3 });
                }
            }
        ]
    },
    "indexmacresearch": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 324,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_macresearch.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v, 12);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月机构宏<br>观研报数量';
                },
                td: function (v) {
                    return "" + (v.count != undefined ? v.count : '');
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'date',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'date',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'date',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return date;
                }
            }
        ]
    },
    "indexnewstock": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                th: function name(v) {
                    return '股票代码';
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.stockCode) + "\">" + v.stockCode + "</a>";
                }
            },
            {
                th: function name(v) {
                    return '股票简称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.stockCode + (".html\">" + fieldtools_1["default"].fmtsname(v.stockName) + "</a>");
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.stockCode + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.stockCode + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                width: 220,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    var date = ((v.publishDate).split(' ')[0]).replace(/-/g, '');
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
                    // return `<a href="/report/ReportRedirect.aspx?date=` + date + `&code=` + v.infoCode + `">${v.title}</a>`
                }
            },
            {
                paramname: 'publishdate',
                th: function name(v) {
                    return '发布日期';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'publishdate',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'publishdate',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'publishdate',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(5, 11) : '';
                    return publishDate;
                }
            },
            {
                paramname: 'purchasedate',
                th: function name(v) {
                    return '申购日期';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'purchasedate',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'purchasedate',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'purchasedate',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    var newPurchaseDate = v.newPurchaseDate ? (v.newPurchaseDate).substring(5, 11) : '';
                    return newPurchaseDate;
                }
            },
            {
                paramname: 'listingdate',
                th: function name(v) {
                    return '上市日期';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'listingdate',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'listingdate',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'listingdate',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    var newListingDate = v.newListingDate ? (v.newListingDate).substring(5, 11) : '';
                    return newListingDate;
                }
            },
            {
                paramname: 'newIssuePrice',
                th: function name(v) {
                    return '发行价';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'newIssuePrice',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'newIssuePrice',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'newIssuePrice',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    return v.newIssuePrice != '' ? Number(v.newIssuePrice).toFixed(2) : '';
                }
            },
            {
                paramname: 'newPeIssueA',
                th: function name(v) {
                    return '发行市<br>盈率';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'newPeIssueA',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'newPeIssueA',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'newPeIssueA',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    return v.newPeIssueA != '' ? Number(v.newPeIssueA).toFixed(2) : '';
                }
            },
            {
                paramname: 'zxj',
                th: function name(v) {
                    return '最新价';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'zxj',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'zxj',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'zxj',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    return '<span class="gghqspan" data-hqtype="zxj" data-market=' + v.market + ' data-code="' + v.stockCode + '"></span>';
                    // return '<span class="gghqspan" data-hqtype="zxj" data-market="SHENZHEN" data-code="300059"></span>'
                }
            },
            {
                paramname: 'zxsyl',
                th: function name(v) {
                    return '最新市盈率';
                },
                // sort: {
                //   asc: {
                //     sortkey: 'zxsyl',
                //     value: 'asc'
                //   },
                //   desc: {
                //     sortkey: 'zxsyl',
                //     value: 'desc'
                //   },
                //   default: {
                //     sortkey: 'zxsyl',
                //     value: ''
                //   }
                // },
                td: function (v) {
                    return '<span class="gghqspan" data-hqtype="zxsyl" data-market=' + v.market + ' data-code="' + v.stockCode + '"></span>';
                }
            },
            // {
            //   paramname:'hysyl',
            //   th: function name(v: any) {
            //     return '行业市盈率'
            //   },
            //   td: function (v: any) {
            //     return '<span class="hqspan" data-hqtype="hysyl" data-code="' + v.indvInduCode + '"></span>'
            //   }
            // },
            {
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            }
        ]
    },
    "indexstrategyreport": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 280,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                width: 220,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v, 20);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月机构策<br>略报告数量';
                },
                td: function (v) {
                    return "" + (v.count != undefined ? v.count : '');
                }
            },
            {
                width: 65,
                th: function name(v) {
                    return '日期';
                },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return date;
                }
            }
        ]
    },
    "indexbroker": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 222,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_brokerreport.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v, 20);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '日期';
                },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return date;
                }
            }
        ]
    },
    "eastmoneyanalyst": {
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 74,
                th: function name(v) {
                    return '分析师名称';
                },
                td: function (v) {
                    return "<a href=\"/invest/invest/" + v.ANALYST_CODE + ".html\">" + v.ANALYST_NAME + "</a>";
                }
            },
            {
                th: function name(v) {
                    return '分析师单位';
                },
                td: function (v) {
                    return v.ORG_NAME;
                }
            },
            {
                th: function name(v) {
                    return '最新指数';
                },
                td: function (v) {
                    return (v.INDEX_VALUE).toFixed(2);
                }
            },
            {
                width: 158,
                th: function name(v) {
                    return '图表';
                },
                td: function (v) {
                    return "<a href=\"/invest/invest/" + v.ANALYST_CODE + ".html\">\u67E5\u770B\u8BE5\u5206\u6790\u5E08\u6307\u6570</a>";
                }
            },
            {
                th: function name(v) {
                    var displayYear = '';
                    var date = new Date();
                    var currentYear = date.getFullYear();
                    var myMonth = date.getMonth() + 1;
                    if (myMonth < 3) {
                        displayYear = currentYear - 1;
                    }
                    else {
                        displayYear = currentYear;
                    }
                    return displayYear + '年收益<br>率<span class="icon icon_desc"></span>';
                },
                td: function (v) {
                    return (v.YEAR_YIELD).toFixed(2) + '%';
                }
            },
            {
                th: function name(v) {
                    return '3个月收益率';
                },
                td: function (v) {
                    return (v.YIELD_3).toFixed(2) + '%';
                }
            },
            {
                th: function name(v) {
                    return '6个月收益率';
                },
                td: function (v) {
                    return (v.YIELD_6).toFixed(2) + '%';
                }
            },
            {
                th: function name(v) {
                    return '成分股个数';
                },
                td: function (v) {
                    return v.SECURITY_COUNT;
                }
            },
            {
                width: 140,
                th: function name(v) {
                    var displayYear = '';
                    var date = new Date();
                    var currentYear = date.getFullYear();
                    var myMonth = date.getMonth() + 1;
                    if (myMonth < 3) {
                        displayYear = currentYear - 1;
                    }
                    else {
                        displayYear = currentYear;
                    }
                    return displayYear + '最新个股评级';
                },
                td: function (v) {
                    return "<a href=\"/invest/invest/" + v.ANALYST_CODE + (".html#new\">" + v.NEWEST_STOCK_RATING + "</a>");
                }
            }
        ]
    },
    "industry": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                th: function name(v) {
                    return '行业名称';
                },
                td: function (v) {
                    var bkcode = v.industryCode ? v.industryCode > 999 ? 'bk' + v.industryCode : 'bk0' + v.industryCode : '';
                    return "<a href=\"//quote.eastmoney.com/center/boardlist.html#boards-" + bkcode + ("\">" + v.industryName + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    return '<span class="hqspan" data-hqtype="zdf" data-code="' + v.industryCode + '"></span>';
                }
            },
            {
                width: 162,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    var bkcode = v.industryCode ? v.industryCode > 999 ? 'bk' + v.industryCode : 'bk0' + v.industryCode : '';
                    return "<a href=\"/report/industry.jshtml?hyid=" + v.industryCode + "\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"/bkzj/" + v.industryCode + ".html\">\u8D44\u91D1\u6D41</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + bkcode + ".html\">\u80A1\u5427</a>&nbsp;\n                  <a href=\"//stock.eastmoney.com/hangye/hy" + v.industryCode + ".html\">\u4E13\u533A</a>";
                }
            },
            {
                width: 222,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_industry.jshtml?infocode=" + v.infoCode + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '-';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级<br>变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月行<br>业研报数';
                },
                td: function (v) {
                    return "" + v.count;
                }
            },
            {
                width: 65,
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var date = (v.publishDate).split(' ')[0];
                    return "" + date;
                }
            }
        ]
    },
    "stock": {
        theadfix: {
            thisyear_ylyc: function (v) {
                var currentYear = v.currentYear ? v.currentYear : '';
                return currentYear + '盈利预测';
            },
            nextyear_ylyc: function (v) {
                var nextyear = v.currentYear ? v.currentYear + 1 : '';
                return nextyear + '盈利预测';
            }
        },
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 60,
                paramname: 'stockCode',
                th: function name(v) {
                    return '股票代码';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'stockCode,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'stockCode,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'stockCode,default'
                    }
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.stockCode) + "\">" + v.stockCode + "</a>";
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '股票简称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.stockCode + (".html\">" + fieldtools_1["default"].fmtsname(v.stockName) + "</a>");
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.stockCode + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.stockCode + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                width: 150,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    var date = ((v.publishDate).split(' ')[0]).replace(/-/g, '');
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
                    // return `<a href="/report/ReportRedirect.aspx?date=` + date + `&code=` + v.infoCode + `">${v.title}</a>`
                }
            },
            {
                th: function name(v) {
                    return '东财<br>评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '-';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级<br>变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                width: 70,
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月<br>个股研<br>报数';
                },
                td: function (v) {
                    return "" + v.count;
                }
            },
            {
                paramname: 'predictThisYearEps',
                th: function (v) {
                    return '收益';
                },
                theadfix: "thisyear_ylyc",
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'predictThisYearEps,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'predictThisYearEps,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'predictThisYearEps,default'
                    }
                },
                td: function (v) {
                    var predictThisYearEps = "";
                    if (v.predictThisYearEps != undefined) {
                        predictThisYearEps = v.predictThisYearEps == '' ? "" : Number(v.predictThisYearEps).toFixed(3);
                    }
                    return predictThisYearEps;
                }
            },
            {
                paramname: 'predictThisYearPe',
                th: function name(v) {
                    return '市盈率';
                },
                theadfix: "thisyear_ylyc",
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'predictThisYearPe,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'predictThisYearPe,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'predictThisYearPe,default'
                    }
                },
                td: function (v) {
                    var predictThisYearPe = "";
                    if (v.predictThisYearPe != undefined) {
                        predictThisYearPe = v.predictThisYearPe == '' ? "" : Number(v.predictThisYearPe).toFixed(2);
                    }
                    return predictThisYearPe;
                }
            },
            {
                paramname: 'predictNextYearEps',
                th: function name(v) {
                    return '收益';
                },
                theadfix: "nextyear_ylyc",
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'predictNextYearEps,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'predictNextYearEps,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'predictNextYearEps,default'
                    }
                },
                td: function (v) {
                    var predictNextYearEps = "";
                    if (v.predictNextYearEps != undefined) {
                        predictNextYearEps = v.predictNextYearEps == '' ? "" : Number(v.predictNextYearEps).toFixed(3);
                    }
                    return predictNextYearEps;
                }
            },
            {
                paramname: 'predictNextYearPe',
                th: function name(v) {
                    return '市盈率';
                },
                theadfix: "nextyear_ylyc",
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'predictNextYearPe,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'predictNextYearPe,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'predictNextYearPe'
                    }
                },
                td: function (v) {
                    var predictNextYearPe = "";
                    if (v.predictNextYearPe != undefined) {
                        predictNextYearPe = v.predictNextYearPe == '' ? "" : Number(v.predictNextYearPe).toFixed(2);
                    }
                    return predictNextYearPe;
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '行业';
                },
                td: function (v) {
                    return "<a href=\"/report/industry.jshtml?hyid=" + v.indvInduCode + ("\">" + v.indvInduName + "</a>");
                }
            },
            {
                width: 65,
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 10) : '';
                    return "" + publishDate;
                }
            }
        ]
    },
    "profitforecast": {
        theadfix: {
            jgtzpj: function (v) {
                return '机构投资评级(近六个月)';
            }
        },
        config: [
            {
                width: 44,
                th: function name(v) {
                    return '序号';
                },
                td: function (v, p) {
                    return v.index + 1 + (p - 1) * 50;
                }
            },
            {
                paramname: 'stockCode',
                th: function name(v) {
                    return '代码';
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v) + "\">" + v.SECURITY_CODE + "</a>";
                }
            },
            {
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.SECURITY_CODE + (".html\">" + fieldtools_1["default"].fmtsname(v.SECURITY_NAME_ABBR) + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                paramname: 'total',
                th: function name(v) {
                    return '研报数';
                },
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_ORG_NUM) ? 0 : v.RATING_ORG_NUM;
                }
            },
            {
                th: function name(v) {
                    return '买入';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_BUY_NUM) ? 0 : v.RATING_BUY_NUM;
                }
            },
            {
                th: function name(v) {
                    return '增持';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_ADD_NUM) ? 0 : v.RATING_ADD_NUM;
                }
            },
            {
                th: function name(v) {
                    return '中性';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_NEUTRAL_NUM) ? 0 : v.RATING_NEUTRAL_NUM;
                }
            },
            {
                th: function name(v) {
                    return '减持';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_REDUCE_NUM) ? 0 : v.RATING_REDUCE_NUM;
                }
            },
            {
                th: function name(v) {
                    return '卖出';
                },
                theadfix: 'jgtzpj',
                td: function (v) {
                    return fieldtools_1["default"].isEmpty(v.RATING_SALE_NUM) ? 0 : v.RATING_SALE_NUM;
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR1;
                    return (year || '') + '每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS1, { num: 3 });
                },
                icons: {
                    name: 'faq',
                    title: "\u9884\u6D4B\u6570\u636E\u6839\u636E\u5404\u673A\u6784\u53D1\u5E03\u7684\u7814\u62A5\u62A5\u544A\u6458\u5F55\u6240\u5F97\uFF0C\u4E0E\u672C\u7F51\u7AD9\u7ACB\u573A\u65E0\u5173\uFF1B\u5B9E\u9645\u6BCF\u80A1\u6536\u76CA\u4E3A\u7ECF\u6700\u65B0\u603B\u80A1\u672C\u8BA1\u7B97\u6240\u5F97"
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR2;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS2, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR3;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS3, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR4;
                    return (year || '') + '预测每股收益';
                },
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS4, { num: 3 });
                }
            }
        ]
    },
    "newstock": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '股票代码';
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.stockCode) + "\">" + v.stockCode + "</a>";
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '股票简称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.stockCode + (".html\">" + fieldtools_1["default"].fmtsname(v.stockName) + "</a>");
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.stockCode + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.stockCode + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                width: 180,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
                }
            },
            {
                width: 54,
                paramname: 'publishDate',
                th: function name(v) {
                    return '发布日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(5, 11) : '';
                    return publishDate;
                }
            },
            {
                width: 54,
                paramname: 'newPurchaseDate',
                th: function name(v) {
                    return '申购日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'newPurchaseDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'newPurchaseDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'newPurchaseDate,default'
                    }
                },
                td: function (v) {
                    var newPurchaseDate = v.newPurchaseDate ? (v.newPurchaseDate).substring(5, 11) : '';
                    return newPurchaseDate;
                }
            },
            {
                width: 54,
                paramname: 'newListingDate',
                th: function name(v) {
                    return '上市日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'newListingDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'newListingDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'newListingDate,default'
                    }
                },
                td: function (v) {
                    var newListingDate = v.newListingDate ? (v.newListingDate).substring(5, 11) : '';
                    return newListingDate;
                }
            },
            {
                width: 44,
                paramname: 'newIssuePrice',
                th: function name(v) {
                    return '发行价';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'newIssuePrice,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'newIssuePrice,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'newIssuePrice,default'
                    }
                },
                td: function (v) {
                    return v.newIssuePrice != '' ? Number(v.newIssuePrice).toFixed(2) : '';
                }
            },
            {
                paramname: 'newPeIssueA',
                th: function name(v) {
                    return '发行市<br>盈率';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'newPeIssueA,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'newPeIssueA,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'newPeIssueA,default'
                    }
                },
                td: function (v) {
                    return v.newPeIssueA != '' ? Number(v.newPeIssueA).toFixed(2) : '';
                }
            },
            {
                th: function name(v) {
                    return '最新价';
                },
                td: function (v) {
                    return '<span class="gghqspan" data-hqtype="zxj" data-market=' + v.market + ' data-code="' + v.stockCode + '"></span>';
                }
            },
            {
                th: function name(v) {
                    return '最新市<br>盈率';
                },
                td: function (v) {
                    return '<span class="gghqspan" data-hqtype="zxsyl" data-market=' + v.market + ' data-code="' + v.stockCode + '"></span>';
                }
            },
            {
                width: 70,
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            }
        ]
    },
    "macresearch": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 288,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_macresearch.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                width: 210,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                width: 120,
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'count',
                th: function name(v) {
                    return '近一月机构宏<br>观研报数量';
                },
                td: function (v) {
                    return "" + (v.count != undefined ? v.count : '');
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    "strategyreport": {
        config: [
            {
                width: 60,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 288,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                width: 180,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                width: 90,
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                width: 90,
                paramname: 'count',
                th: function name(v) {
                    return '近一月机构策略报告数量';
                },
                td: function (v) {
                    return "" + (v.count != undefined ? v.count : '');
                }
            },
            {
                width: 90,
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    "brokerreport": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 268,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_brokerreport.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                width: 220,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                width: 220,
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    "orgpublish": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 282,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    //return `<a>${v.title}</a>`
                    return getZWUrl(v);
                }
            },
            {
                th: function name(v) {
                    return '报告类型';
                },
                td: function (v) {
                    return geTypeUrl(v);
                }
            },
            {
                th: function name(v) {
                    return '研究对象';
                },
                td: function (v) {
                    return getYJDXUrl(v);
                }
            },
            {
                width: 180,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).split(' ')[0] : '';
                    return publishDate;
                }
            }
        ]
    },
    "personalpublish": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 282,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return getZWUrl(v);
                }
            },
            {
                th: function name(v) {
                    return '报告类型';
                },
                td: function (v) {
                    return geTypeUrl(v);
                }
            },
            {
                th: function name(v) {
                    return '研究对象';
                },
                td: function (v) {
                    return getYJDXUrl(v);
                }
            },
            {
                width: 180,
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).split(' ')[0] : '';
                    return publishDate;
                }
            }
        ]
    },
    "singlestock": {
        config: [
            {
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 248,
                th: function name(v) {
                    return '报告名称';
                },
                td: function (v) {
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财<br>评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '-';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级<br>变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                th: function name(v) {
                    return '作者';
                },
                td: function (v) {
                    var authorStr = authorFormat(v);
                    return authorStr;
                }
            },
            {
                th: function name(v) {
                    return '机构';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                paramname: 'publishDate',
                th: function name(v) {
                    return '日期';
                },
                sort: {
                    asc: {
                        sortkey: 'sort',
                        value: 'publishDate,asc'
                    },
                    desc: {
                        sortkey: 'sort',
                        value: 'publishDate,desc'
                    },
                    "default": {
                        sortkey: 'sort',
                        value: 'publishDate,default'
                    }
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).split(' ')[0] : '';
                    return publishDate;
                }
            }
        ]
    },
    //------------正文----------
    //策略报告正文：策略报告
    "zw_stratyge": {
        config: [
            {
                width: 312,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                width: 160,
                th: function name(v) {
                    return '研究员';
                },
                td: function (v) {
                    var arr = v.researcher.split(',');
                    if (arr.length < 4) {
                        return "<span>" + v.researcher + "</span>";
                    }
                    else {
                        return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                    }
                }
            }
        ]
    },
    //策略报告正文：zuixin
    "zw_neweast": {
        config: [
            {
                width: 312,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_strategy.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                width: 160,
                th: function name(v) {
                    return '研究员';
                },
                td: function (v) {
                    var arr = v.researcher.split(',');
                    if (arr.length < 4) {
                        return "<span>" + v.researcher + "</span>";
                    }
                    else {
                        return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                    }
                }
            }
        ]
    },
    //策略报告正文：热门行业追踪 
    "zw_hotindustry": {},
    //行业研报正文：文中涉及到的个股
    "zw_industry_stock": {
        config: [
            {
                th: function name(v) {
                    return '代码';
                },
                td: function (v) {
                    return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.code) + "\">" + v.code + "</a>";
                }
            },
            {
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.code + (".html\">" + fieldtools_1["default"].fmtsname(v.name) + "</a>");
                }
            },
            {
                width: 120,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.code + ".html\">\u7814\u62A5</a>&nbsp;\n                  <a href=\"/zjlx/" + v.code + ".html\">\u8D44\u91D1\u6D41</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.code + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                th: function name(v) {
                    return '最新价';
                },
                td: function (v) {
                    var $span;
                    if (v.zde < 0) {
                        $span = "<span class='green'>" + v.zxj + "</span>";
                    }
                    else if (v.zde > 0) {
                        $span = "<span class='red'>" + v.zxj + "</span>";
                    }
                    else {
                        $span = "<span class=''>" + v.zxj + "</span>";
                    }
                    return $span;
                }
            },
            {
                th: function name(v) {
                    return '涨跌额';
                },
                td: function (v) {
                    var $span;
                    if (v.zde < 0) {
                        $span = "<span class='green'>" + v.zde + "</span>";
                    }
                    else if (v.zde > 0) {
                        $span = "<span class='red'>" + v.zde + "</span>";
                    }
                    else {
                        $span = "<span class=''>" + v.zde + "</span>";
                    }
                    return $span;
                }
            },
            {
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    var $span;
                    if (v.zde < 0) {
                        $span = "<span class='green'>" + v.zdf + "</span>";
                    }
                    else if (v.zde > 0) {
                        $span = "<span class='red'>" + v.zdf + "</span>";
                    }
                    else {
                        $span = "<span class=''>" + v.zdf + "</span>";
                    }
                    return $span;
                }
            }
        ]
    },
    //行业研报正文：所在行业最新研究报告
    "zw_indsneweast": {
        config: [
            {
                width: 312,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    var title = v.title;
                    return "<a href=\"/report/zw_industry.jshtml?infocode=" + v.infoCode + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '评级变动';
                },
                td: function (v) {
                    var ratingChangeName = getRatingChangeStr(v.ratingChange);
                    return "" + ratingChangeName;
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            }
        ]
    },
    //行业研报正文  ：热门行业评级一览
    "zw_indshotstock": {
        theadfix: {
            orgGrade_6: function (v) {
                return '机构投资评级（近六个月）';
            }
        },
        config: [
            {
                width: 60,
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.code + (".html\">" + fieldtools_1["default"].fmtsname(v.name) + "</a>");
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    var zdf = v.zdf;
                    var span = '';
                    // span = zdf == '-' ? span = zdf : String(zdf).indexOf('-')>-1 ? span = '<span class="green">' + zdf + '%</span>' : span = '<span class="red">' + zdf + '%</span>';
                    if (zdf > 0) {
                        span = '<span class="red">' + zdf + '%</span>';
                    }
                    else if (zdf < 0) {
                        span = '<span class="green">' + zdf + '%</span>';
                    }
                    else if (zdf == 0) {
                        span = '<span>0.00%</span>';
                    }
                    else if (zdf == '-') {
                        span = '<span>-</span>';
                    }
                    return span;
                    // return '<span class="gghqspan" data-hqtype="zdf" data-market="'+v.market+'" data-code="' + v.stockCode + '"></span>'
                }
            },
            {
                width: 40,
                th: function name(v) {
                    return '研报数';
                },
                td: function (v) {
                    // return !!v.total ? `<a href="">` + v.total+`</a>` :''
                    return v.total !== '' ? v.total : '';
                }
            },
            {
                th: function name(v) {
                    return '买入';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateBuy;
                }
            },
            {
                th: function name(v) {
                    return '增持';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateIncrease;
                }
            },
            {
                th: function name(v) {
                    return '中性';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateNeutral;
                }
            },
            {
                th: function name(v) {
                    return '减持';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateReduce;
                }
            },
            {
                th: function name(v) {
                    return '卖出';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateSellout;
                }
            }
        ]
    },
    //行业研报正文  ：行业个股未来3年盈利预测
    "zw_indsstockforecast": {
        config: [
            {
                width: 60,
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.SECURITY_CODE + (".html\">" + fieldtools_1["default"].fmtsname(v.SECURITY_NAME_ABBR) + "</a>");
                }
            },
            {
                width: 70,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.SECURITY_CODE + ".html\" class=\"red\">\u8BE6\u7EC6</a>&nbsp;\n          <a href=\"//guba.eastmoney.com/list," + v.SECURITY_CODE + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR2;
                    return (year || '') + '<br>预测收益';
                },
                // theadfix: 'thisyear_ycsy',
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS2, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR3;
                    return (year || '') + '<br>预测收益';
                },
                // theadfix: 'nextyear_ycsy',
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS3, { num: 3 });
                }
            },
            {
                th: function name(v) {
                    var _a, _b, _c;
                    var year = (_c = (_b = (_a = v.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.YEAR4;
                    return (year || '') + '<br>预测收益';
                },
                // theadfix: 'afteryear_ycsy',
                td: function (v) {
                    return fieldtools_1["default"].fieldfmt(v.EPS4, { num: 3 });
                }
            }
        ]
    },
    //行业研报正文：热门行业追踪
    "zw_indshotindustry": {
        config: [
            {
                width: 80,
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    // return `<a>${v.name}</a>`   
                    return "<a href=\"//quote.eastmoney.com/center/boardlist.html#boards-" + v.code + ("\">" + v.name + "</a>");
                    // return `<a href="//quote.eastmoney.com/center/list.html#` + v.stockcode+`">${v.name}</a>`
                }
            },
            {
                width: 40,
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    var zdf = v.zdf;
                    var span = '';
                    if (zdf > 0) {
                        span = '<span class="red">' + zdf + '%</span>';
                    }
                    else if (zdf < 0) {
                        span = '<span class="green">' + zdf + '%</span>';
                    }
                    else if (zdf == 0) {
                        span = '<span>0.00%</span>';
                    }
                    if (zdf == '-') {
                        span = zdf;
                    }
                    return span;
                }
            },
            {
                width: 70,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    var bkcode = v.code;
                    bkcode = bkcode.charAt(2) == '0' ? bkcode.substring(3) : bkcode.substring(2);
                    return "<a href=\"/report/industry.jshtml?hyid=" + bkcode + "\">\u7814\u62A5</a>\n                  <a href=\"/bkzj/" + bkcode + ".html\">\u8D44\u91D1\u6D41</a>";
                }
            },
            {
                width: 60,
                th: function name(v) {
                    return '领涨股票';
                },
                td: function (v) {
                    return v.lzgp == '-' ? v.lzgp : "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(v.stockcode) + "\">" + v.lzgp + "</a>";
                }
            },
            {
                width: 70,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.stockcode + ".html\">\u7814\u62A5</a>\n                  <a href=\"/zjlx/" + v.stockcode + ".html\">\u8D44\u91D1\u6D41</a>";
                }
            }
        ]
    },
    //行业正文：个股财务指标 
    "zw_indggcw_table": {
        config: [
            {
                width: 30,
                th: function name(v) {
                    return '序号';
                },
                td: function (v) {
                    return v.index + 1;
                }
            },
            {
                width: 90,
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.code + (".html\">" + fieldtools_1["default"].fmtsname(v.name) + "</a>");
                }
            },
            {
                width: 90,
                th: function name(v) {
                    return '相关';
                },
                td: function (v) {
                    return "<a href=\"/report/" + v.code + ".html\">\u7814\u62A5</a>&nbsp;\n                  <a href=\"//guba.eastmoney.com/list," + v.code + ".html\">\u80A1\u5427</a>";
                }
            },
            {
                th: function name(v) {
                    var fid = v.data.data[0].fid;
                    var titlename = '';
                    if (fid == 'f112') {
                        titlename = '每股收益(元)';
                    }
                    else if (fid == 'f113') {
                        titlename += '每股净资产(元)';
                    }
                    else if (fid == 'f37') {
                        titlename = '净资产收益率(%)';
                    }
                    else if (fid == 'f48') {
                        titlename = '每股未分配利润(元)';
                    }
                    else if (fid == 'f45') {
                        titlename = '净利润(亿元)';
                    }
                    else if (fid == 'f40') {
                        titlename = '营业收入(亿元)';
                    }
                    else if (fid == 'f41') {
                        titlename = '营业收入同比(%)';
                    }
                    return titlename;
                    // return '<span>每股收益(元)</span>'
                },
                td: function (v) {
                    // let profit = v.value ? Number(v.value).toFixed(2):'';
                    return v.value;
                }
            }
        ]
    },
    //宏观研究正文 ：最新宏观研究
    "zw_macsearch": {
        config: [
            {
                width: 312,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_macresearch.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                width: 160,
                th: function name(v) {
                    return '研究员';
                },
                td: function (v) {
                    var arr = v.researcher.split(',');
                    if (arr.length < 4) {
                        return "<span>" + v.researcher + "</span>";
                    }
                    else {
                        return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                    }
                }
            }
        ]
    },
    //券商晨报正文：最新券商 
    "zw_broker": {
        config: [
            {
                width: 212,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_brokerreport.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '研究员';
                },
                td: function (v) {
                    var arr = v.researcher.split(',');
                    if (arr.length < 4) {
                        return "<span>" + v.researcher + "</span>";
                    }
                    else {
                        return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                    }
                }
            }
        ]
    },
    //券商晨报正文：最新研究  暂定
    "zw_neweastbroker": {
        config: [
            {
                width: 312,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    return "<a href=\"/report/zw_macresearch.jshtml?encodeUrl=" + v.encodeUrl + ("\">" + v.title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(0, 11) : '';
                    return publishDate;
                }
            },
            {
                th: function name(v) {
                    return '机构名称';
                },
                td: function (v) {
                    return "<a href=\"/report/orgpublish.jshtml?orgcode=" + v.orgCode + ("\">" + (v.orgSName ? v.orgSName : v.orgName) + "</a>");
                }
            },
            {
                width: 160,
                th: function name(v) {
                    return '研究员';
                },
                td: function (v) {
                    var arr = v.researcher.split(',');
                    if (arr.length < 4) {
                        return "<span>" + v.researcher + "</span>";
                    }
                    else {
                        return "<span title=\"" + arr.join(',') + "\">" + arr.slice(0, 3).join(',') + "...</span>";
                    }
                }
            }
        ]
    },
    //单个个股正文行业最新
    "zw_indsneweast_stock": {
        config: [
            {
                width: 180,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    var title = utils_1["default"].txtLeft(v.title, 24, true);
                    return "<a href=\"/report/zw_industry.jshtml?infocode=" + v.infoCode + ("\">" + title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(5, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    "zw_orgneweast_stock": {
        config: [
            {
                width: 180,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    var title = utils_1["default"].txtLeft(v.title, 24, true);
                    // return `<a href="zw_industry.jshtml?infocode=` + v.infoCode + `">${title}</a>`
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(5, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    "zw_stockneweast_stock": {
        config: [
            {
                width: 180,
                th: function name(v) {
                    return '标题';
                },
                td: function (v) {
                    var title = utils_1["default"].txtLeft(v.title, 24, true);
                    return "<a href=\"/report/info/" + v.infoCode + (".html\">" + title + "</a>");
                }
            },
            {
                th: function name(v) {
                    return '东财评级';
                },
                td: function (v) {
                    var emRatingName = v.emRatingName ? v.emRatingName : '';
                    return "" + emRatingName;
                },
                icons: {
                    name: 'faq',
                    title: "\u6839\u636E\u673A\u6784\u62AB\u9732\u7684\u8BC4\u7EA7\u8BF4\u660E\u5212\u5206\u4E1C\u8D22\u8BC4\u7EA7\u6807\u51C6"
                }
            },
            {
                th: function name(v) {
                    return '报告日期';
                },
                td: function (v) {
                    var publishDate = v.publishDate ? (v.publishDate).substring(5, 11) : '';
                    return publishDate;
                }
            }
        ]
    },
    //个股研报正文  ：热门行业评级一览
    "zw_indshotstockpj": {
        theadfix: {
            orgGrade_6: function (v) {
                return '机构投资评级（近六个月）';
            }
        },
        config: [
            {
                width: 50,
                th: function name(v) {
                    return '名称';
                },
                td: function (v) {
                    return "<a href=\"/stockdata/" + v.code + (".html\">" + fieldtools_1["default"].fmtsname(v.name) + "</a>");
                }
            },
            {
                width: 50,
                th: function name(v) {
                    return '涨跌幅';
                },
                td: function (v) {
                    var zdf = v.zdf;
                    var span = '';
                    // span = zdf == '-' ? span = zdf : String(zdf).indexOf('-')>-1 ? span = '<span class="green">' + zdf + '%</span>' : span = '<span class="red">' + zdf + '%</span>';
                    if (zdf > 0) {
                        span = '<span class="red">' + zdf + '%</span>';
                    }
                    else if (zdf < 0) {
                        span = '<span class="green">' + zdf + '%</span>';
                    }
                    else if (zdf == 0) {
                        span = '<span>0.00%</span>';
                    }
                    else if (zdf == '-') {
                        span = '<span>-</span>';
                    }
                    return span;
                    // return '<span class="gghqspan" data-hqtype="zdf" data-market="'+v.market+'" data-code="' + v.stockCode + '"></span>'
                }
            },
            {
                width: 40,
                th: function name(v) {
                    return '研报数';
                },
                td: function (v) {
                    // return !!v.total ? `<a href="">` + v.total+`</a>` :''
                    return v.total !== '' ? v.total : '';
                }
            },
            {
                th: function name(v) {
                    return '买入';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateBuy;
                }
            },
            {
                th: function name(v) {
                    return '增持';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateIncrease;
                }
            },
            {
                th: function name(v) {
                    return '中性';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateNeutral;
                }
            },
            {
                th: function name(v) {
                    return '减持';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateReduce;
                }
            },
            {
                th: function name(v) {
                    return '卖出';
                },
                theadfix: 'orgGrade_6',
                td: function (v) {
                    return v.rateSellout;
                }
            }
        ]
    }
};
exports["default"] = config;
